<template>
  <div id="qrTag">
    <vue-qr :size="500" class="qrTag" ref="qrTag" :text="qrValue"/>
    <b-icon-printer class="d-block cursor-pointer h5 mt-2" @click="printImage()"/>
  </div>
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'

export default {
  name: "QrGenerator",
  components: {vueQr},
  props: {
    qrValue: {
      require: true
    }
  },
  methods: {
    printImage() {
      const qrImageSrc = this.$refs.qrTag.$el.currentSrc;
      var newWindow = window.open("https://www.example.com", "_blank");
      newWindow.document.write(`<html><head><title>QR</title></head><body> <img src='${qrImageSrc}' alt='mixitweb.com'> </body></html>`);
    }
  }
}
</script>

<style>
#qrTag img {
  width: 75px;
  height: 75px;
}
.cursor-pointer{
  cursor: pointer;
}
</style>